export const ScrollTopRef = (element, options = {
    behavior: "smooth",
    block: "start",
}) => {
    if (element.current) {
        // Usar requestAnimationFrame en lugar de setTimeout
        requestAnimationFrame(() => {
            var _a, _b, _c;
            const elementTop = (_b = (_a = element.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().top) !== null && _b !== void 0 ? _b : 0;
            // Prevenir scroll si el elemento ya está visible
            if (elementTop < 0 || elementTop > window.innerHeight) {
                try {
                    (_c = element.current) === null || _c === void 0 ? void 0 : _c.scrollIntoView(options);
                }
                catch (error) {
                    window.scrollTo({
                        top: elementTop + window.pageYOffset - 20,
                        behavior: "smooth"
                    });
                }
            }
        });
    }
};
